import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import VideoSection from "@/components/VideoSection";
import About from "@/components/About";
import PhotoCarousel from "@/components/PhotoCarousel";
import SocialSection from "@/components/SocialSection";
import Footer from "@/components/Footer";
import BlogSection from "@/components/BlogSection";
import CompanySection from "@/components/CompanySection";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEO from "@/components/SEO";
import HomeStructuredData from "@/components/HomeStructuredData";
import FAQ from "@/components/FAQ";
import WhyChooseUs from "@/components/WhyChooseUs";
import Testimonials from "@/components/Testimonials";
import TrustBar from "@/components/TrustBar";
import NextStep from "@/components/NextStep";

const homeFAQ = [
  { q: "O que é psicoterapia e quando devo procurar?", a: "Psicoterapia é um processo de cuidado em saúde mental conduzido por um psicólogo registrado no CRP. Ela é indicada sempre que você sentir que emoções, pensamentos ou comportamentos estão afetando sua qualidade de vida, relacionamentos ou trabalho — não é preciso esperar uma crise para buscar acolhimento profissional." },
  { q: "Como funciona a avaliação neuropsicológica na Equilybra?", a: "A avaliação neuropsicológica investiga funções cognitivas como atenção, memória, linguagem, raciocínio e funções executivas. O processo envolve entrevista inicial, aplicação de testes padronizados em algumas sessões e devolutiva com laudo técnico, útil para diagnósticos como TDAH, TEA, dificuldades de aprendizagem e declínio cognitivo." },
  { q: "Vocês atendem online ou só presencial no Ipiranga?", a: "Atendemos das duas formas. O consultório fica na Rua Agostinho Gomes, 3319 — Ipiranga, São Paulo, próximo ao metrô Sacomã. A psicoterapia também é oferecida online por videochamada, com a mesma ética e qualidade, para pacientes em todo o Brasil." },
  { q: "Quantas sessões dura a psicoterapia breve?", a: "Nossa modalidade padrão é a Psicoterapia Breve Focal, com duração de 18 sessões semanais. O foco é trabalhar uma demanda específica do paciente em um período definido, com objetivos claros desde a primeira sessão." },
  { q: "Como funciona a avaliação pré-cirúrgica para bariátrica ou plástica?", a: "Realizamos a avaliação pré-cirúrgica em um protocolo de 4 encontros, ao final dos quais é emitido o laudo psicológico exigido pela equipe médica para cirurgia bariátrica ou plástica." },
  { q: "Como agendar uma consulta?", a: "Você pode agendar pelo WhatsApp (11) 97697-4905, pelo telefone (11) 2305-0747 ou pelo formulário da página de Contato. Respondemos em horário comercial, de segunda a sábado." },
];

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Equilybra Psicologia | Clínica no Ipiranga — São Paulo"
        description="Clínica de Psicologia no Ipiranga, SP: psicoterapia (breve, TCC, casal, infantil, adolescente), avaliação neuropsicológica, psicodiagnóstico, perícia e orientação vocacional. Presencial e online."
        path="/"
      />
      <HomeStructuredData />
      <a href="#conteudo-principal" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md">
        Pular para o conteúdo principal
      </a>
      <Navbar />
      <main id="conteudo-principal">
        <Hero />
        <TrustBar />
        <VideoSection />
        <About />
        <PhotoCarousel />
        <WhyChooseUs />
        <Testimonials />
        <SocialSection />
        <FAQ items={homeFAQ} noSchema title="Perguntas frequentes" subtitle="As principais dúvidas de quem busca a Equilybra Psicologia." />
        <NextStep />
        <BlogSection />
        <CompanySection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
